<template>
  <div class="welcome container">
    <div class="card">
      <div class="card-content center-align">
        <h2 class="blue-text">Chatterbox</h2>
        <form @submit.prevent='enterChat'>
          <label for="name">Enter your name: </label>
          <input type="text" name="name" v-model="name">
          <p v-if="feedback" class="red-text"> {{ feedback }} </p>
          <button class="btn blue">Enter Chatterbox</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data () {
    return {
      name: null,
      feedback: null
    }
  },
  methods: {
    enterChat() {
      // console.log(this.name)
      if (this.name) {
        this.$router.push({ name: 'Chat', params: {name: this.name} })
      }else {
        this.feedback = 'Please enter your name to join'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.welcome {
  max-width: 400px;
  margin-top: 100px;
}

.welcome h2 {
  font-size: 4em;
}

.welcome button {
  margin: 30px auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue